'use client';

// Root-layout error boundary — promoted to the shared @owlcat/ui template
// (markup is byte-identical to the previous local copy, so no visual change).
// Catches crashes route-level error.tsx cannot (errors in the root layout
// itself). Next requires this FILE to be a Client Component even though it only
// re-exports the (already "use client") shared component.
export { GlobalError as default } from '@owlcat/ui';
